import { faUserSecret } from "@fortawesome/pro-solid-svg-icons/faUserSecret";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from "@mui/material/Grid";
import { APP_FOOTER_LINK, APP_FOOTER_LINK_NAME, APP_NAME } from "app/appConstants";
import { MprcClickable } from "components";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { AboutDialog } from "views/public/AboutDialog";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const Footer: React.FC = () => {
    const session = useSession();
    const [showAbout, setShowAbout] = useState<boolean>(false);
    const { t } = useTranslation("shared");

    return (
        <>
            {showAbout && <AboutDialog onClose={() => setShowAbout(false)} />}

            <Grid container alignItems="center" justifyContent="space-between">
                <Grid>
                    <a href={APP_FOOTER_LINK} target="_blank" rel="noreferrer">{APP_FOOTER_LINK_NAME}</a>
                </Grid>
                {
                    session.user.spyUserId &&
                    <Grid>
                        <FontAwesomeIcon icon={faUserSecret} fixedWidth />
                        <Trans t={t} i18nKey="App.Spy.Message" values={{ spyname: session.user.spyUsername, name: session.user.name }}></Trans>
                    </Grid>
                }
                <Grid>
                    <MprcClickable onClick={() => setShowAbout(true)}> {APP_NAME} - {session.appBuild?.buildVersion}</MprcClickable>
                </Grid>
            </Grid>
        </>
    );
};
